import { render, staticRenderFns } from "./institutional-logos-banner.vue?vue&type=template&id=5c9c4f6e&scoped=true"
import script from "./institutional-logos-banner.vue?vue&type=script&lang=js"
export * from "./institutional-logos-banner.vue?vue&type=script&lang=js"
import style0 from "./institutional-logos-banner.vue?vue&type=style&index=0&id=5c9c4f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9c4f6e",
  null
  
)

export default component.exports